import {
  AhuTable,
  AhuTableFilters,
} from "@/services/backend/htz/ahu/components/ahu-table";
import { ListRequest } from "@/services/backend/htz/ahu/api/ahu-api";
import { ReactNode, useCallback, useMemo, useState } from "react";
import { NavLink, useParams } from "react-router";
import { TableCard } from "@/shared/components/tables/table-card";
import t from "@/lang/lang";
import { CreateAhuDialog } from "@/services/backend/htz/ahu/components/create-ahu-dialog";
import { CustomerPageBreadcrumbs } from "../../_components/customer-page-breadcrumbs";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "../../_components/customer-page";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";

export function CustomerHtzAhuListRoute() {
  const { customerId } = useParams();
  const { companyId } = useActiveCompany();

  const [request, setRequest] = useState<ListRequest>({
    company: {
      active: true,
      values: [companyId],
    },
    customer: {
      active: true,
      values: [customerId!],
    },
  });

  const renderRowLink = useCallback(
    (ahuId: string, children: ReactNode) => (
      <NavLink to={`/customers/${customerId}/htz/ahus/${ahuId}`}>
        {children}
      </NavLink>
    ),
    [customerId],
  );

  const breadcrumbs = useMemo(
    () => [
      {
        to: `/customers/${customerId}/htz/ahus`,
        label: t("HTZ"),
      },
      {
        to: `/customers/${customerId}/htz/ahus`,
        label: t("RLT-Anlagen"),
      },
    ],
    [customerId],
  );

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs breadcrumbs={breadcrumbs} />
      </CustomerPageMainHeader>
      <CustomerPageMainContent className="gap-2">
        <div className="flex items-center justify-between">
          <AhuTableFilters
            request={request}
            onRequestChange={setRequest}
            hideCustomerFilter
          />
          <CreateAhuDialog companyId={companyId} customerId={customerId} />
        </div>
        <TableCard>
          <AhuTable request={request} renderRowLink={renderRowLink} />
        </TableCard>
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
